<template>
  <div class="chat">
    <div class="toolbar text-right" v-if="toolbar">
      <b-button variant="link" class="close-button" @click="$emit('close')">
        <i class="togo-icon togo-icon-closes togo-icon-lg"></i>
      </b-button>
    </div>

    <div class="message-list" ref="messageList">
      <chat-message-list :messages="messages"></chat-message-list>
    </div>

    <div class="chat-form-layout" v-show="showForm">
      <chat-form
        ref="form"
        :recipients="recipients" @chat="send" @chat-input-focus="onChatInputFocus"
        :chatEnabled="chatEnabled" :questionsEnabled="questionsEnabled">
      </chat-form>
    </div>
  </div>
</template>

<script>
import ChatMessageList from './chat-message-list';
import ChatForm from './chat-form';

const messageTime = (m) => (m.timeAnswered || m.timeAsked || m.time);

const Chat = {
  name: 'Chat',

  components: {
    ChatMessageList,
    ChatForm
  },

  props: {
    toolbar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      recipientsLength: 0
    };
  },

  mounted() {
    this.scrollToForm();
  },

  computed: {
    recipients() {
      const onlineParticipants = this.$store.getters['g2wSession/onlineParticipants'];

      const recipients = {};
      this.messages
        .filter((message) => !message.questionText)
        .forEach((message) => {
          if (message.received) {
            recipients[message.senderId] = onlineParticipants[message.senderId];
          } else {
            recipients[message.recipientId] = onlineParticipants[message.recipientId];
          }
        });

      this.recipientsLength = Object.keys(recipients).length;
      return recipients;
    },

    messages() {
      const chatMessages = this.$store.state.g2wSession.chatMessages;
      const questions = this.$store.state.g2wSession.questions.all;

      return chatMessages.concat(questions).sort((m1, m2) => messageTime(m1) - messageTime(m2));
    },

    chatEnabled() {
      return this.$store.getters['g2wSession/chatEnabled'];
    },

    questionsEnabled() {
      return this.$store.getters['g2wSession/questionsEnabled'];
    },

    showForm() {
      return this.questionsEnabled
          || (this.chatEnabled && this.recipientsLength > 0);
    }
  },

  methods: {
    send({chatMessage, question}) {
      if (chatMessage) {
        this.$telemetryTrack('send chat');
        this.$store.dispatch('g2wSession/sendChatMessage', {chatMessage});
      }

      if (question) {
        this.$telemetryTrack('send question');
        this.$store.dispatch('sendQuestion', {question});
      }
    },

    async scrollToForm() {
      await this.$nextTick();
      if (this.$refs.form.$el.scrollIntoView) {
        this.$refs.form.$el.scrollIntoView();
      }
    },

    onChatInputFocus(focused) {
      this.$emit('chat-input-focus', focused);
      this.scrollToForm();
    }
  }
};

export default Chat;
</script>

<style lang="sass">
  @import "src/scss/variables";

  .chat
    width: 100%
    max-height: 100%
    display: flex
    flex-direction: column
    align-items: center

    .close-button
      pointer: cursor

    .toolbar
      background: transparent !important
      color: black !important

    .message-list
      width: 100%
      margin: 10px 0
      overflow-y: auto

    .chat-form-layout
      width: 100%

</style>
